import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref, watch } from "vue";
import InlineSvg from "vue-inline-svg";
import { IFilter, IOption } from "@/domain/entities/filter/filter.types";
import SelectModal from "../modal/base/SelectModal.vue";


const __default__ = {
  name: "CustomSelect",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  filter: {
    type: Object as PropType<IFilter>,
    required: true,
  },
  placeholder: {
    type: String,
    default: "선택",
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: true,
  },
  ariaLabel: {
    type: String,
    default: "",
  },
},
  emits: ["onSelectOption"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

const emit = __emit;

const optionNames = computed(() =>
  props.filter.availableOptions.map((option) => option.name)
);

const defaultOption = computed(() => {
  const dummyOptionName = props.filter?.dummyOptionName;
  const defaultOption = props.filter?.availableOptions.find(
    (option) => option.default
  ) ?? {
    key: "",
    name: dummyOptionName ? dummyOptionName : props.placeholder,
  };
  return defaultOption;
});

const selectedOptionOfFilter = computed(() => {
  return Array.isArray(props.filter.selectedOptions)
    ? props.filter.selectedOptions?.[0]
    : props.filter.selectedOptions;
});

const selectedOption = ref<IOption>(
  selectedOptionOfFilter.value ?? defaultOption.value
);
const selectedOptionIndex = computed(
  () =>
    props.filter.availableOptions.findIndex(
      (option) =>
        option.key === selectedOption.value.key &&
        option.name === selectedOption.value.name
    ) ?? -1
);

const showOptions = ref(false);
const selectButtonRef = ref<HTMLElement | null>(null);

const toggleShowOptions = () => {
  if (!props.filter?.availableOptions.length || props.disabled) return;
  showOptions.value = !showOptions.value;
};

const hideOptions = () => {
  showOptions.value = false;
};

const onClickOption = (index: number) => {
  if (props.disabled) return;

  selectedOption.value = props.filter.availableOptions[index];
  emit("onSelectOption", props.filter, selectedOption.value);
  hideOptions();
};

const handleShowOptions = () => {
  toggleShowOptions();
  // SelectModal이 열릴 때 포커스 이동은 SelectModal에서 처리
};

const handleHideOptions = () => {
  hideOptions();
  // 모달이 닫힐 때 select 버튼으로 포커스 복귀
  selectButtonRef.value?.focus();
};

watch(
  () => props.filter.selectedOptions,
  (newVal) => {
    const newSelectedOption = Array.isArray(newVal) ? newVal[0] : newVal;
    selectedOption.value = newSelectedOption ?? defaultOption.value;
  }
);

const selectLabelId = computed(() =>
  props.label
    ? `custom-select-label-${Math.random().toString(36).substr(2, 9)}`
    : undefined
);

const __returned__ = { props, emit, optionNames, defaultOption, selectedOptionOfFilter, selectedOption, selectedOptionIndex, showOptions, selectButtonRef, toggleShowOptions, hideOptions, onClickOption, handleShowOptions, handleHideOptions, selectLabelId, get InlineSvg() { return InlineSvg }, SelectModal }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})